// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { listSchools, createSchool, updateSchool, deleteSchool, getSchoolDeleteCheck, provisionSchoolUser, grantAdminAccess, listSchoolAdmins, revokeSchoolAdminAccess, updateSchoolAdminAccessLevel, resetSchoolAdminPassword, deleteSchoolAdminAccount, listSchoolAdminAudit, listSchoolTeachers, resetSchoolTeacherPassword, deleteSchoolTeacher, listDemoUsers, createDemoUser, resetDemoUser, getStandardsScopeRulesSummary, getStandardsScopeRules, saveStandardsScopeRules, getSchoolStandardsScope, saveSchoolScienceSource, fetchStandardsProgressionData, createDistrictOnboarding, listBillingDistricts, resendDistrictInvite, forceDistrictBillingStatus } from "../../services/api";
import { useAuth } from "../../context/AuthContext";
import BackToTop from "../../components/BackToTop";
import ModalPortal from "../../components/ModalPortal";
import FamilyDisplaySettingsPanel from "../../components/Superadmin/FamilyDisplaySettingsPanel";
import ActionCardFlagsPanel from "../../components/Superadmin/ActionCardFlagsPanel";

const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
  "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
  "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri",
  "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York",
  "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
  "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
  "West Virginia", "Wisconsin", "Wyoming",
];

const SCOPE_SUBJECTS = ["Mathematics", "Literacy", "Science", "Social Studies"];
const SCOPE_GRADE_BANDS = ["PK", "K-5", "6-8", "9-12"];
const SCOPE_TIME_FRAME_TYPES = ["year", "quarter", "trimester", "semester", "unit"];

function mapGradeToBand(rawGrade) {
  const grade = String(rawGrade || "").trim().toUpperCase().replace(/^(\d+)\s+TO\s+(\d+)$/, "$1-$2");
  if (grade === "PK") return "PK";
  if (["K", "1", "2", "3", "4", "5"].includes(grade)) return "K-5";
  if (["6", "7", "8", "6-8"].includes(grade)) return "6-8";
  if (["9", "10", "11", "12", "9-10", "11-12", "9-12"].includes(grade)) return "9-12";
  return "";
}

export default function SuperadminHome() {
  const { user } = useAuth();
  const [schools, setSchools] = useState<any>([]);
  const [loadingSchools, setLoadingSchools] = useState<any>(false);
  const [feedback, setFeedback] = useState<any>("");
  const [error, setError] = useState<any>("");
  const [deleteChecks, setDeleteChecks] = useState<any>({});
  const [blockerModal, setBlockerModal] = useState({ open: false, data: null });

  const [newSchool, setNewSchool] = useState({ name: "", address: "", phone: "", state: "" });
  const [newDistrict, setNewDistrict] = useState({
    district_name: "",
    district_code: "",
    school_name: "",
    school_address: "",
    school_phone: "",
    school_state: "",
    admin_first_name: "",
    admin_last_name: "",
    admin_email: "",
    seat_quantity: "100",
    is_pilot: true,
    billing_interval: "annual",
    send_invite: true,
  });
  const [districtResult, setDistrictResult] = useState<any>(null);
  const [creatingDistrict, setCreatingDistrict] = useState(false);
  const [billingDistricts, setBillingDistricts] = useState<any>([]);
  const statusBannerRef = useRef(null);
  const [editingId, setEditingId] = useState<any>(null);
  const [preferencesSchoolId, setPreferencesSchoolId] = useState<any>("");
  const [editSchool, setEditSchool] = useState({ name: "", address: "", phone: "", state: "" });

  const [provision, setProvision] = useState({
    school_id: "",
    role: "admin",
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    send_invite: false,
  });
  const [showProvisionPassword, setShowProvisionPassword] = useState<any>(true);
  const [demoUsers, setDemoUsers] = useState<any>([]);
  const [loadingDemoUsers, setLoadingDemoUsers] = useState<any>(false);
  const [resettingDemoUserId, setResettingDemoUserId] = useState<any>(null);
  const [demoProvision, setDemoProvision] = useState({
    first_name: "",
    last_name: "",
    role: "school_admin",
    email: "",
    password: "",
  });
  const [showDemoProvisionPassword, setShowDemoProvisionPassword] = useState<any>(true);

  const [grantAdmin, setGrantAdmin] = useState({
    school_id: "",
    email: "",
    access_level: "school_admin",
  });
  const [adminAccessSchoolId, setAdminAccessSchoolId] = useState<any>("");
  const [schoolAdmins, setSchoolAdmins] = useState<any>([]);
  const [loadingSchoolAdmins, setLoadingSchoolAdmins] = useState<any>(false);
  const [adminAccessEdits, setAdminAccessEdits] = useState<any>({});
  const [resettingAdminId, setResettingAdminId] = useState<any>(null);
  const [deletingAdminId, setDeletingAdminId] = useState<any>(null);
  const [adminRevealedPasswords, setAdminRevealedPasswords] = useState<any>({});
  const [adminAuditEvents, setAdminAuditEvents] = useState<any>([]);
  const [loadingAdminAudit, setLoadingAdminAudit] = useState<any>(false);
  const [adminAuditTotal, setAdminAuditTotal] = useState<any>(0);
  const [adminAuditPage, setAdminAuditPage] = useState(1);
  const [adminAuditLimit, setAdminAuditLimit] = useState(25);
  const [adminAuditActionPrefix, setAdminAuditActionPrefix] = useState<any>("");
  const [adminAuditStartDate, setAdminAuditStartDate] = useState<any>("");
  const [adminAuditEndDate, setAdminAuditEndDate] = useState<any>("");
  const [adminAuditPreset, setAdminAuditPreset] = useState<any>("");
  const [adminAuditSearchTerm, setAdminAuditSearchTerm] = useState<any>("");

  const [teacherSchoolId, setTeacherSchoolId] = useState<any>("");
  const [teachers, setTeachers] = useState<any>([]);
  const [loadingTeachers, setLoadingTeachers] = useState<any>(false);
  const [resettingTeacherId, setResettingTeacherId] = useState<any>(null);
  const [deletingTeacherId, setDeletingTeacherId] = useState<any>(null);
  const [revealedPasswords, setRevealedPasswords] = useState<any>({});

  const [allStandardsData, setAllStandardsData] = useState<any>([]);
  const [loadingAllStandards, setLoadingAllStandards] = useState<any>(false);
  const [scopeState, setScopeState] = useState<any>("");
  const [scopeSubject, setScopeSubject] = useState(SCOPE_SUBJECTS[0]);
  const [scopeGradeBand, setScopeGradeBand] = useState(SCOPE_GRADE_BANDS[0]);
  const [scopeTimeFrameType, setScopeTimeFrameType] = useState(SCOPE_TIME_FRAME_TYPES[0]);
  const [scopeTimeFrameLabel, setScopeTimeFrameLabel] = useState<any>("");
  const [scopeSelectedCodes, setScopeSelectedCodes] = useState(new Set());
  const [loadingScopeRules, setLoadingScopeRules] = useState<any>(false);
  const [savingScopeRules, setSavingScopeRules] = useState<any>(false);
  const [scopeSummary, setScopeSummary] = useState<any>([]);
  const [loadingScopeSummary, setLoadingScopeSummary] = useState<any>(false);
  const [scopeMessage, setScopeMessage] = useState<any>("");
  const [scopeError, setScopeError] = useState<any>("");
  const [schoolScopeId, setSchoolScopeId] = useState<any>("");
  const [districtScopeSource, setDistrictScopeSource] = useState("missouri");

  const loadSchools = async () => {
    setLoadingSchools(true);
    setError("");
    try {
      const data = await listSchools();
      setSchools(data.schools || []);
    } catch (e: any) {
      setError(e.message || "Failed to load schools");
    } finally {
      setLoadingSchools(false);
    }
  };

  useEffect(() => {
    loadSchools();
    loadDemoUsers();
  }, []);

  const loadDemoUsers = async () => {
    setLoadingDemoUsers(true);
    try {
      const data = await listDemoUsers();
      setDemoUsers(data.demo_users || []);
    } catch (err: any) {
      setError(err.message || "Failed to load demo users");
    } finally {
      setLoadingDemoUsers(false);
    }
  };

  useEffect(() => {
    let cancelled = false;
    setLoadingAllStandards(true);
    fetchStandardsProgressionData()
      .then((data) => {
        if (!cancelled) setAllStandardsData(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setAllStandardsData([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingAllStandards(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const loadScopeSummary = async (state) => {
    if (!state) {
      setScopeSummary([]);
      return;
    }
    setLoadingScopeSummary(true);
    setScopeError("");
    try {
      const data = await getStandardsScopeRulesSummary(state);
      setScopeSummary(data.scopes || []);
    } catch (err: any) {
      setScopeError(err.message || "Failed to load configured scopes for this state");
    } finally {
      setLoadingScopeSummary(false);
    }
  };

  const loadScopeRules = async (overrides = {}) => {
    const state = overrides.state ?? scopeState;
    const subject = overrides.subject ?? scopeSubject;
    const gradeBand = overrides.gradeBand ?? scopeGradeBand;
    const timeFrameType = overrides.timeFrameType ?? scopeTimeFrameType;
    const timeFrameLabel = (overrides.timeFrameLabel ?? scopeTimeFrameLabel).trim();

    if (!state || !subject || !gradeBand || !timeFrameType || !timeFrameLabel) {
      setScopeError("Select a state, subject, grade band, time frame type, and time frame label first.");
      return;
    }
    setLoadingScopeRules(true);
    setScopeError("");
    setScopeMessage("");
    try {
      const data = await getStandardsScopeRules({
        state,
        subject,
        gradeBand,
        timeFrameType,
        timeFrameLabel,
      });
      setScopeSelectedCodes(new Set(data.mls_codes || []));
    } catch (err: any) {
      setScopeError(err.message || "Failed to load standards for this scope");
    } finally {
      setLoadingScopeRules(false);
    }
  };

  const loadSchoolScopeRules = async (overrides = {}) => {
    const schoolId = overrides.schoolId ?? schoolScopeId;
    const subject = overrides.subject ?? scopeSubject;
    const standardSource = overrides.standardSource ?? districtScopeSource;
    const gradeBand = overrides.gradeBand ?? scopeGradeBand;
    const timeFrameType = overrides.timeFrameType ?? scopeTimeFrameType;
    const timeFrameLabel = (overrides.timeFrameLabel ?? scopeTimeFrameLabel).trim();
    if (!schoolId) return;
    setScopeError("");
    try {
      const data = await getSchoolStandardsScope(schoolId);
      const scienceSet = (data.sets || []).find((item) => item.subject === "Science");
      if (scienceSet?.standard_source) {
        setDistrictScopeSource(scienceSet.standard_source);
      }
      const selected = (data.sets || []).find((item) => (
        item.subject === subject && item.standard_source === standardSource && item.grade_band === gradeBand &&
        item.time_frame_type === timeFrameType && item.time_frame_label === timeFrameLabel
      ));
      setScopeSelectedCodes(new Set(selected?.mls_codes || []));
    } catch (err: any) {
      setScopeError(err.message || "Failed to load school standards preference");
    }
  };

  const handleEditScope = async (scope) => {
    setScopeSubject(scope.subject);
    setScopeGradeBand(scope.grade_band);
    setScopeTimeFrameType(scope.time_frame_type);
    setScopeTimeFrameLabel(scope.time_frame_label);
    await loadScopeRules({
      state: scopeState,
      subject: scope.subject,
      gradeBand: scope.grade_band,
      timeFrameType: scope.time_frame_type,
      timeFrameLabel: scope.time_frame_label,
    });
  };

  const handleDeleteScope = async (scope) => {
    const confirmed = window.confirm(
      `Delete the scope ${scope.subject} \u00b7 ${scope.grade_band} \u00b7 ${scope.time_frame_type} "${scope.time_frame_label}"?\n\nThis removes all ${scope.standard_count} visible standard(s) configured for it.`
    );
    if (!confirmed) return;

    setScopeError("");
    setScopeMessage("");
    try {
      await saveStandardsScopeRules({
        state: scopeState,
        subject: scope.subject,
        gradeBand: scope.grade_band,
        timeFrameType: scope.time_frame_type,
        timeFrameLabel: scope.time_frame_label,
        mlsCodes: [],
      });
      setScopeMessage(`Deleted scope ${scope.subject} \u00b7 ${scope.grade_band} \u00b7 ${scope.time_frame_type} "${scope.time_frame_label}".`);
      if (
        scopeSubject === scope.subject &&
        scopeGradeBand === scope.grade_band &&
        scopeTimeFrameType === scope.time_frame_type &&
        scopeTimeFrameLabel === scope.time_frame_label
      ) {
        setScopeSelectedCodes(new Set());
      }
      await loadScopeSummary(scopeState);
    } catch (err: any) {
      setScopeError(err.message || "Failed to delete this scope");
    }
  };

  const toggleScopeCode = (code) => {
    setScopeSelectedCodes((prev) => {
      const next = new Set(prev);
      if (next.has(code)) {
        next.delete(code);
      } else {
        next.add(code);
      }
      return next;
    });
  };

  const scopeCandidateStandards = allStandardsData
    .filter((row) => row.subject === scopeSubject && mapGradeToBand(row.grade_level) === scopeGradeBand)
    .filter((row) => row.standard_source === (schoolScopeId && scopeSubject === "Science" ? districtScopeSource : "missouri"))
    .reduce((acc, row) => {
      if (row.mls_code && !acc.some((item) => item.mls_code === row.mls_code)) {
        acc.push(row);
      }
      return acc;
    }, [])
    .sort((a, b) => String(a.mls_code).localeCompare(String(b.mls_code), undefined, { numeric: true }));

  const handleSaveScopeRules = async () => {
    if (!scopeState || !scopeSubject || !scopeGradeBand || !scopeTimeFrameType || !scopeTimeFrameLabel.trim()) {
      setScopeError("Select a state, subject, grade band, time frame type, and time frame label first.");
      return;
    }
    setSavingScopeRules(true);
    setScopeError("");
    setScopeMessage("");
    try {
      const result = await saveStandardsScopeRules({
        state: scopeState,
        subject: scopeSubject,
        gradeBand: scopeGradeBand,
        timeFrameType: scopeTimeFrameType,
        timeFrameLabel: scopeTimeFrameLabel.trim(),
        mlsCodes: Array.from(scopeSelectedCodes),
      });
      setScopeMessage(`Saved ${result.count} visible standard${result.count === 1 ? "" : "s"} for ${scopeTimeFrameType} "${scopeTimeFrameLabel.trim()}".`);
      await loadScopeSummary(scopeState);
    } catch (err: any) {
      setScopeError(err.message || "Failed to save standards scope");
    } finally {
      setSavingScopeRules(false);
    }
  };

  const handleSaveSchoolScienceSource = async () => {
    if (!schoolScopeId) {
      setScopeError("Select a school first.");
      return;
    }
    setSavingScopeRules(true);
    setScopeError("");
    setScopeMessage("");
    try {
      await saveSchoolScienceSource(schoolScopeId, districtScopeSource);
      setScopeMessage(`Saved ${districtScopeSource === "ngss" ? "NGSS" : "Missouri"} Science standards for all grades at this school.`);
      await loadSchoolScopeRules();
    } catch (err: any) {
      setScopeError(err.message || "Failed to save school Science standards preference");
    } finally {
      setSavingScopeRules(false);
    }
  };

  const loadSchoolAdminAudit = async (
    schoolId,
    opts = {
      page: adminAuditPage,
      limit: adminAuditLimit,
      actionPrefix: adminAuditActionPrefix,
      startDate: adminAuditStartDate,
      endDate: adminAuditEndDate,
    }
  ) => {
    if (!schoolId) {
      setAdminAuditEvents([]);
      setAdminAuditTotal(0);
      return;
    }

    setLoadingAdminAudit(true);
    setError("");
    try {
      const data = await listSchoolAdminAudit(Number(schoolId), opts);
      setAdminAuditEvents(data.events || []);
      setAdminAuditTotal(data.total || 0);
    } catch (err: any) {
      setError(err.message || "Failed to load admin audit");
    } finally {
      setLoadingAdminAudit(false);
    }
  };

  const loadBillingDistricts = async () => {
    try {
      const data = await listBillingDistricts();
      setBillingDistricts(data.items || []);
    } catch {
      /* optional panel */
    }
  };

  useEffect(() => {
    loadBillingDistricts();
  }, []);

  useEffect(() => {
    if (!error && !feedback && !districtResult) return;
    const target = statusBannerRef.current;
    if (target && typeof target.scrollIntoView === "function") {
      target.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [error, feedback, districtResult]);

  const copyDistrictSetupLink = async (link: string) => {
    try {
      await navigator.clipboard.writeText(link);
      setError("");
      setFeedback("Setup link copied to clipboard.");
    } catch {
      setError("Could not copy setup link — select and copy it manually.");
    }
  };

  const handleResendDistrictInvite = async () => {
    if (!districtResult?.district?.district_id || !districtResult?.admin?.user_id) return;
    setError("");
    setFeedback("");
    try {
      const r = await resendDistrictInvite(districtResult.district.district_id, districtResult.admin.user_id);
      setDistrictResult((prev) => ({ ...prev, invite: r }));
      if (r?.invite_sent) {
        setFeedback(`Invite resent to ${districtResult.admin?.email || "admin"}.`);
      } else {
        setError(r?.error || "Invite email failed to send — copy the setup link and share it manually.");
        if (r?.setup_link) {
          setFeedback("Fresh setup link is ready in the result card — copy and share it.");
        }
      }
    } catch (err: any) {
      setError(err.message || "Resend failed");
    }
  };

  const handleCreateDistrict = async (e) => {
    e.preventDefault();
    setError("");
    setFeedback("");
    setCreatingDistrict(true);
    setDistrictResult(null);
    try {
      const result = await createDistrictOnboarding({
        district_name: newDistrict.district_name,
        district_code: newDistrict.district_code || null,
        school_name: newDistrict.school_name,
        school_address: newDistrict.school_address || null,
        school_phone: newDistrict.school_phone || null,
        school_state: newDistrict.school_state || null,
        admin_email: newDistrict.admin_email,
        admin_first_name: newDistrict.admin_first_name,
        admin_last_name: newDistrict.admin_last_name,
        seat_quantity: Number(newDistrict.seat_quantity),
        is_pilot: Boolean(newDistrict.is_pilot),
        billing_interval: newDistrict.billing_interval,
        send_invite: Boolean(newDistrict.send_invite),
      });
      setDistrictResult(result);
      setFeedback(
        `Created district ${result.district?.name} (id ${result.district?.district_id}). ` +
          (result.invite?.invite_sent
            ? "Invite email sent — copyable setup link is in the result card below."
            : "Invite not emailed — copy the setup link from the result card below.")
      );
      setNewDistrict({
        district_name: "",
        district_code: "",
        school_name: "",
        school_address: "",
        school_phone: "",
        school_state: "",
        admin_first_name: "",
        admin_last_name: "",
        admin_email: "",
        seat_quantity: "100",
        is_pilot: true,
        billing_interval: "annual",
        send_invite: true,
      });
      await loadSchools();
      await loadBillingDistricts();
    } catch (err: any) {
      setError(err.message || "Failed to create district");
    } finally {
      setCreatingDistrict(false);
    }
  };

  const handleCreateSchool = async (e) => {
    e.preventDefault();
    setFeedback("");
    setError("");
    try {
      await createSchool(newSchool);
      setFeedback("School created successfully.");
      setNewSchool({ name: "", address: "", phone: "", state: "" });
      await loadSchools();
    } catch (e1: any) {
      setError(e1.message || "Failed to create school");
    }
  };

  const startEdit = (s) => {
    setEditingId(s.school_id);
    setEditSchool({
      name: s.name || "",
      address: s.address || "",
      phone: s.phone || "",
      state: s.state || "",
    });
  };

  const saveEdit = async (schoolId) => {
    setFeedback("");
    setError("");
    try {
      await updateSchool(schoolId, editSchool);
      setFeedback("School updated successfully.");
      setEditingId(null);
      await loadSchools();
    } catch (e2: any) {
      setError(e2.message || "Failed to update school");
    }
  };

  const handleDeleteSchool = async (school) => {
    const confirmed = window.confirm(
      `Delete school "${school.name}" (ID: ${school.school_id})?\n\nThis only works when no users are assigned to that school.`
    );
    if (!confirmed) return;

    const typedName = window.prompt(
      `Type the exact school name to confirm deletion:\n\n${school.name}`
    );

    if (typedName !== school.name) {
      setError("Deletion cancelled: school name did not match exactly.");
      return;
    }

    setFeedback("");
    setError("");
    try {
      await deleteSchool(school.school_id);
      setFeedback(`School "${school.name}" deleted.`);
      await loadSchools();
    } catch (e4: any) {
      setError(e4.message || "Failed to delete school");
    }
  };

  const handleCheckDeleteSchool = async (school) => {
    setFeedback("");
    setError("");
    try {
      const check = await getSchoolDeleteCheck(school.school_id);
      setDeleteChecks((prev) => ({ ...prev, [school.school_id]: check }));

      if (check.can_delete) {
        setFeedback(`School "${school.name}" is eligible for deletion.`);
      } else {
        setBlockerModal({ open: true, data: check });
      }
    } catch (err: any) {
      setError(err.message || "Failed to check delete constraints");
    }
  };

  const handleProvisionUser = async (e) => {
    e.preventDefault();
    setFeedback("");
    setError("");
    if (!provision.school_id) {
      setError("Select a school first.");
      return;
    }
    try {
      const result = await provisionSchoolUser(Number(provision.school_id), {
        email: provision.email,
        password: provision.password,
        first_name: provision.first_name,
        last_name: provision.last_name,
        role: provision.role,
        send_invite: provision.send_invite,
      });
      const inviteNote = provision.send_invite
        ? (result?.credentials?.invite_sent ? " Invite email sent." : " Invite email failed to send — share the credentials manually.")
        : "";
      setFeedback(`${provision.role} user provisioned successfully.${inviteNote}`);
      setProvision((prev) => ({
        ...prev,
        first_name: "",
        last_name: "",
        email: "",
        password: "",
      }));
    } catch (e3: any) {
      setError(e3.message || "Failed to provision user");
    }
  };

  const handleCreateDemoUser = async (e) => {
    e.preventDefault();
    setFeedback("");
    setError("");
    try {
      const result = await createDemoUser({
        ...demoProvision,
        email: demoProvision.email || undefined,
        password: demoProvision.password || undefined,
      });
      setDemoUsers((prev) => [result.demo_user, ...prev]);
      setFeedback(`Demo user created. Login: ${result.credentials.login_email} | Temporary password: ${result.credentials.temporary_password}`);
      setDemoProvision({ first_name: "", last_name: "", role: "school_admin", email: "", password: "" });
    } catch (err: any) {
      setError(err.message || "Failed to create demo user");
    }
  };

  const handleResetDemoUser = async (demoUser) => {
    if (!window.confirm(`Reset ${demoUser.email}? All activity in this isolated demo school will be deleted, but the login will remain available.`)) return;
    setFeedback("");
    setError("");
    setResettingDemoUserId(demoUser.user_id);
    try {
      await resetDemoUser(demoUser.user_id);
      setFeedback(`Reset demo activity for ${demoUser.email}.`);
    } catch (err: any) {
      setError(err.message || "Failed to reset demo user");
    } finally {
      setResettingDemoUserId(null);
    }
  };

  const handleGrantAdminAccess = async (e) => {
    e.preventDefault();
    setFeedback("");
    setError("");
    if (!grantAdmin.school_id || !grantAdmin.email) {
      setError("Select school and provide admin email.");
      return;
    }
    try {
      const res = await grantAdminAccess(Number(grantAdmin.school_id), {
        email: grantAdmin.email,
        access_level: grantAdmin.access_level,
      });

      if (res.granted && String(grantAdmin.school_id) === String(adminAccessSchoolId)) {
        setSchoolAdmins((prev) => {
          const exists = prev.some((row) => row.user_id === res.user_id);
          if (exists) {
            return prev.map((row) =>
              row.user_id === res.user_id
                ? { ...row, access_level: res.access_level }
                : row
            );
          }
          return [
            {
              admin_school_id: `new-${res.user_id}-${res.school_id}`,
              user_id: res.user_id,
              email: res.email,
              first_name: "",
              last_name: "",
              access_level: res.access_level,
            },
            ...prev,
          ];
        });
        setAdminAccessEdits((prev) => ({ ...prev, [res.user_id]: res.access_level }));
      }

      setFeedback(
        res.granted
          ? `Granted ${grantAdmin.email} access to school ${grantAdmin.school_id}.`
          : `${grantAdmin.email} already has access to this school.`
      );
      setGrantAdmin((prev) => ({ ...prev, email: "" }));
      if (String(grantAdmin.school_id) === String(adminAccessSchoolId)) {
        await loadSchoolAdminAudit(adminAccessSchoolId, {
          page: 1,
          limit: adminAuditLimit,
          actionPrefix: adminAuditActionPrefix,
          startDate: adminAuditStartDate,
          endDate: adminAuditEndDate,
        });
        setAdminAuditPage(1);
      }
    } catch (e5: any) {
      setError(e5.message || "Failed to grant admin access");
    }
  };

  const loadSchoolAdmins = async (schoolId) => {
    if (!schoolId) {
      setSchoolAdmins([]);
      return;
    }
    await loadSchoolAdminAudit(schoolId);
    setLoadingSchoolAdmins(true);
    setError("");
    try {
      const data = await listSchoolAdmins(Number(schoolId));
      setSchoolAdmins(data.admins || []);
      const nextEdits = {};
      (data.admins || []).forEach((adm) => {
        nextEdits[adm.user_id] = adm.access_level;
      });
      setAdminAccessEdits(nextEdits);
    } catch (err: any) {
      setError(err.message || "Failed to load school admins");
    } finally {
      setLoadingSchoolAdmins(false);
    }
  };

  const handleRevokeAdminAccess = async (adminRow) => {
    const confirmed = window.confirm(
      `Revoke ${adminRow.email} (${adminRow.access_level}) from school ${adminAccessSchoolId}?`
    );
    if (!confirmed) return;

    setFeedback("");
    setError("");
    try {
      await revokeSchoolAdminAccess(Number(adminAccessSchoolId), adminRow.user_id);
      setFeedback(`Revoked access for ${adminRow.email}.`);
      setSchoolAdmins((prev) => prev.filter((row) => row.user_id !== adminRow.user_id));
      setAdminAccessEdits((prev) => {
        const next = { ...prev };
        delete next[adminRow.user_id];
        return next;
      });
      await loadSchoolAdminAudit(adminAccessSchoolId, {
        page: 1,
        limit: adminAuditLimit,
        actionPrefix: adminAuditActionPrefix,
        startDate: adminAuditStartDate,
        endDate: adminAuditEndDate,
      });
      setAdminAuditPage(1);
    } catch (err: any) {
      setError(err.message || "Failed to revoke admin access");
    }
  };

  const handleUpdateAdminAccessLevel = async (adminRow) => {
    const nextLevel = adminAccessEdits[adminRow.user_id] || adminRow.access_level;
    if (nextLevel === adminRow.access_level) {
      setFeedback(`No access-level change for ${adminRow.email}.`);
      return;
    }

    setFeedback("");
    setError("");
    try {
      await updateSchoolAdminAccessLevel(Number(adminAccessSchoolId), adminRow.user_id, nextLevel);
      setFeedback(`Updated ${adminRow.email} to ${nextLevel}.`);
      setSchoolAdmins((prev) =>
        prev.map((row) =>
          row.user_id === adminRow.user_id
            ? { ...row, access_level: nextLevel }
            : row
        )
      );
      setAdminAccessEdits((prev) => ({ ...prev, [adminRow.user_id]: nextLevel }));
      await loadSchoolAdminAudit(adminAccessSchoolId, {
        page: 1,
        limit: adminAuditLimit,
        actionPrefix: adminAuditActionPrefix,
        startDate: adminAuditStartDate,
        endDate: adminAuditEndDate,
      });
      setAdminAuditPage(1);
    } catch (err: any) {
      setError(err.message || "Failed to update admin access level");
    }
  };

  const handleResetAdminPassword = async (adminRow) => {
    const confirmed = window.confirm(
      `Issue a new temporary password for ${adminRow.first_name || ""} ${adminRow.last_name || ""} (${adminRow.email})?\n\nThey will be required to change it on next login.`
    );
    if (!confirmed) return;

    setFeedback("");
    setError("");
    setResettingAdminId(adminRow.user_id);
    try {
      const result = await resetSchoolAdminPassword(Number(adminAccessSchoolId), adminRow.user_id);
      setAdminRevealedPasswords((prev) => ({ ...prev, [adminRow.user_id]: result.temporary_password }));
      setFeedback(`New temporary password issued for ${adminRow.email}. Share it securely — it will not be shown again.`);
    } catch (err: any) {
      setError(err.message || "Failed to reset admin password");
    } finally {
      setResettingAdminId(null);
    }
  };

  const handleDeleteAdminAccount = async (adminRow) => {
    const confirmed = window.confirm(
      `Delete the account for ${adminRow.first_name || ""} ${adminRow.last_name || ""} (${adminRow.email})?\n\nThis removes their access to ALL schools, not just this one, and cannot be undone.`
    );
    if (!confirmed) return;

    setFeedback("");
    setError("");
    setDeletingAdminId(adminRow.user_id);
    try {
      await deleteSchoolAdminAccount(Number(adminAccessSchoolId), adminRow.user_id);
      setSchoolAdmins((prev) => prev.filter((row) => row.user_id !== adminRow.user_id));
      setAdminAccessEdits((prev) => {
        const next = { ...prev };
        delete next[adminRow.user_id];
        return next;
      });
      setAdminRevealedPasswords((prev) => {
        const next = { ...prev };
        delete next[adminRow.user_id];
        return next;
      });
      setFeedback(`Deleted admin account for ${adminRow.email}.`);
      await loadSchoolAdminAudit(adminAccessSchoolId, {
        page: 1,
        limit: adminAuditLimit,
        actionPrefix: adminAuditActionPrefix,
        startDate: adminAuditStartDate,
        endDate: adminAuditEndDate,
      });
      setAdminAuditPage(1);
    } catch (err: any) {
      setError(err.message || "Failed to delete admin account");
    } finally {
      setDeletingAdminId(null);
    }
  };

  const loadSchoolTeachers = async (schoolId) => {
    if (!schoolId) {
      setTeachers([]);
      return;
    }
    setLoadingTeachers(true);
    setError("");
    try {
      const data = await listSchoolTeachers(Number(schoolId));
      setTeachers(data.teachers || []);
    } catch (err: any) {
      setError(err.message || "Failed to load teachers");
    } finally {
      setLoadingTeachers(false);
    }
  };

  const handleResetTeacherPassword = async (teacher) => {
    const confirmed = window.confirm(
      `Issue a new temporary password for ${teacher.first_name || ""} ${teacher.last_name || ""} (${teacher.email})?\n\nThey will be required to change it on next login.`
    );
    if (!confirmed) return;

    setFeedback("");
    setError("");
    setResettingTeacherId(teacher.user_id);
    try {
      const result = await resetSchoolTeacherPassword(Number(teacherSchoolId), teacher.user_id);
      setRevealedPasswords((prev) => ({ ...prev, [teacher.user_id]: result.temporary_password }));
      setTeachers((prev) =>
        prev.map((t) => (t.user_id === teacher.user_id ? { ...t, must_change_password: true } : t))
      );
      setFeedback(`New temporary password issued for ${teacher.email}. Share it securely — it will not be shown again.`);
    } catch (err: any) {
      setError(err.message || "Failed to reset teacher password");
    } finally {
      setResettingTeacherId(null);
    }
  };

  const handleDeleteTeacher = async (teacher) => {
    const confirmed = window.confirm(
      `Delete ${teacher.first_name || ""} ${teacher.last_name || ""} (${teacher.email})?\n\nThis is blocked if they are still the primary teacher of an active class.`
    );
    if (!confirmed) return;

    setFeedback("");
    setError("");
    setDeletingTeacherId(teacher.user_id);
    try {
      await deleteSchoolTeacher(Number(teacherSchoolId), teacher.user_id);
      setTeachers((prev) => prev.filter((t) => t.user_id !== teacher.user_id));
      setRevealedPasswords((prev) => {
        const next = { ...prev };
        delete next[teacher.user_id];
        return next;
      });
      setFeedback(`Deleted teacher ${teacher.email}.`);
    } catch (err: any) {
      setError(err.message || "Failed to delete teacher");
    } finally {
      setDeletingTeacherId(null);
    }
  };

  const adminAuditTotalPages = Math.max(1, Math.ceil(adminAuditTotal / adminAuditLimit));

  const parseAuditAction = (actionText = "") => {
    const [actionKey, ...rest] = String(actionText).split(" ");
    const tokens = rest.filter(Boolean);
    const details = {};
    tokens.forEach((token) => {
      const [key, value] = token.split("=");
      if (key && value !== undefined) details[key] = value;
    });

    const actionLabelMap = {
      admin_access_granted: "Admin access granted",
      admin_access_revoked: "Admin access revoked",
      admin_access_level_updated: "Admin access level updated",
    };

    return {
      actionLabel: actionLabelMap[actionKey] || actionKey || "Audit event",
      details,
    };
  };

  const formatAuditTimestamp = (timestamp) => {
    if (!timestamp) return "unknown time";
    const parsed = new Date(timestamp);
    if (Number.isNaN(parsed.getTime())) return timestamp;
    return parsed.toLocaleString();
  };

  const normalizedAuditSearch = adminAuditSearchTerm.trim().toLowerCase();
  const preferencesSchool = schools.find((school) => String(school.school_id) === preferencesSchoolId);
  const filteredAdminAuditEvents = normalizedAuditSearch
    ? adminAuditEvents.filter((evt) => {
        const parsed = parseAuditAction(evt.action);
        const actor = String(evt.actor_email || "").toLowerCase();
        const targetUser = String(parsed.details.target_user_id || "").toLowerCase();
        const accessLevel = String(parsed.details.access_level || "").toLowerCase();
        const actionLabel = String(parsed.actionLabel || "").toLowerCase();
        const rawAction = String(evt.action || "").toLowerCase();
        return (
          actor.includes(normalizedAuditSearch) ||
          targetUser.includes(normalizedAuditSearch) ||
          accessLevel.includes(normalizedAuditSearch) ||
          actionLabel.includes(normalizedAuditSearch) ||
          rawAction.includes(normalizedAuditSearch)
        );
      })
    : adminAuditEvents;

  const toDateInputString = (dateObj) => {
    const y = dateObj.getFullYear();
    const m = String(dateObj.getMonth() + 1).padStart(2, "0");
    const d = String(dateObj.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const applyAuditDatePreset = async (daysBack, presetKey) => {
    const today = new Date();
    const end = toDateInputString(today);
    const startDateObj = new Date(today);
    startDateObj.setDate(today.getDate() - daysBack);
    const start = toDateInputString(startDateObj);

    setAdminAuditStartDate(start);
    setAdminAuditEndDate(end);
    setAdminAuditPreset(presetKey);
    setAdminAuditPage(1);

    if (adminAccessSchoolId) {
      await loadSchoolAdminAudit(adminAccessSchoolId, {
        page: 1,
        limit: adminAuditLimit,
        actionPrefix: adminAuditActionPrefix,
        startDate: start,
        endDate: end,
      });
    }
  };

  return (
    <div style={{ display: "grid", gap: 16 }}>
      <h1 style={{ margin: 0, color: "#3256a2" }}>Superadmin Control Panel</h1>

      <div ref={statusBannerRef} style={{ display: "grid", gap: 8 }}>
        {feedback && (
          <div role="status" style={{ color: "#065f46", background: "#ecfdf5", border: "1px solid #a7f3d0", padding: 10, borderRadius: 8 }}>
            {feedback}
          </div>
        )}
        {error && (
          <div role="alert" style={{ color: "#991b1b", background: "#fef2f2", border: "1px solid #fecaca", padding: 10, borderRadius: 8 }}>
            {error}
          </div>
        )}
        {districtResult ? (
          <div
            role="region"
            aria-label="District create result"
            style={{ border: "1px solid #bfdbfe", background: "#eff6ff", borderRadius: 8, padding: 12, display: "grid", gap: 8, fontSize: 13, color: "#1e3a8a" }}
          >
            <div style={{ fontWeight: 700, fontSize: 14, color: "#1e40af" }}>District create result</div>
            <div>
              <strong>{districtResult.district?.name || "District"}</strong>
              {districtResult.district?.district_id != null ? ` (id ${districtResult.district.district_id})` : ""}
              {districtResult.school?.name ? ` · first school: ${districtResult.school.name}` : ""}
            </div>
            <div>
              Admin: {districtResult.admin?.email || "—"}
              {districtResult.admin?.first_name || districtResult.admin?.last_name
                ? ` (${[districtResult.admin?.first_name, districtResult.admin?.last_name].filter(Boolean).join(" ")})`
                : ""}
            </div>
            <div>
              Invite:{" "}
              {districtResult.invite?.invite_sent
                ? "email sent"
                : districtResult.invite?.error
                  ? `not sent — ${districtResult.invite.error}`
                  : "not emailed"}
            </div>
            {districtResult.invite?.setup_link ? (
              <div style={{ display: "grid", gap: 8 }}>
                <div style={{ wordBreak: "break-all" }}>
                  <strong>Setup link:</strong> {districtResult.invite.setup_link}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  <button
                    type="button"
                    onClick={() => copyDistrictSetupLink(districtResult.invite.setup_link)}
                    style={{ background: "#3256a2", color: "#fff", border: "none", borderRadius: 6, padding: "6px 10px", cursor: "pointer" }}
                  >
                    Copy setup link
                  </button>
                  {districtResult.admin?.user_id ? (
                    <button
                      type="button"
                      onClick={handleResendDistrictInvite}
                      style={{ background: "#e5e7eb", color: "#111827", border: "none", borderRadius: 6, padding: "6px 10px", cursor: "pointer" }}
                    >
                      Resend invite
                    </button>
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>

      <ActionCardFlagsPanel />

      <section aria-labelledby="school-preferences-heading" style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 id="school-preferences-heading" style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>School Preferences</h2>
        <label htmlFor="school-preferences-select" style={{ display: "block", fontSize: 13, fontWeight: 700, marginBottom: 6 }}>School</label>
        <select
          id="school-preferences-select"
          value={preferencesSchoolId}
          onChange={(event) => setPreferencesSchoolId(event.target.value)}
          disabled={loadingSchools}
          style={{ width: "100%", padding: 8, border: "1px solid #d1d5db", borderRadius: 6, marginBottom: 14 }}
        >
          <option value="">Select a school</option>
          {schools.map((school) => <option key={school.school_id} value={school.school_id}>{school.name}</option>)}
        </select>
        {preferencesSchool ? (
          <FamilyDisplaySettingsPanel key={preferencesSchool.school_id} schoolId={preferencesSchool.school_id} schoolName={preferencesSchool.name} />
        ) : (
          <div style={{ fontSize: 13, color: "#6b7280" }}>Select a school to manage its family and student display preferences.</div>
        )}
      </section>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>Create District</h2>
        <p style={{ margin: "0 0 12px", fontSize: 13, color: "#6b7280" }}>
          Ops-assisted paid onboarding: creates district + first school + district admin invite with payment required.
        </p>
        <form onSubmit={handleCreateDistrict} style={{ display: "grid", gap: 8 }}>
          <input aria-label="District name" placeholder="District Name" value={newDistrict.district_name} onChange={(e) => setNewDistrict((p) => ({ ...p, district_name: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <input aria-label="District code" placeholder="District Code (optional)" value={newDistrict.district_code} onChange={(e) => setNewDistrict((p) => ({ ...p, district_code: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <input aria-label="First school name" placeholder="First School Name" value={newDistrict.school_name} onChange={(e) => setNewDistrict((p) => ({ ...p, school_name: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <input aria-label="School address" placeholder="School Address" value={newDistrict.school_address} onChange={(e) => setNewDistrict((p) => ({ ...p, school_address: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <input aria-label="School phone" placeholder="School Phone" value={newDistrict.school_phone} onChange={(e) => setNewDistrict((p) => ({ ...p, school_phone: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <select aria-label="School state" value={newDistrict.school_state} onChange={(e) => setNewDistrict((p) => ({ ...p, school_state: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
            <option value="">Select State (for standards scope)</option>
            {US_STATES.map((st) => <option key={st} value={st}>{st}</option>)}
          </select>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            <input aria-label="Admin first name" placeholder="Admin First Name" value={newDistrict.admin_first_name} onChange={(e) => setNewDistrict((p) => ({ ...p, admin_first_name: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
            <input aria-label="Admin last name" placeholder="Admin Last Name" value={newDistrict.admin_last_name} onChange={(e) => setNewDistrict((p) => ({ ...p, admin_last_name: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          </div>
          <input aria-label="Admin email" type="email" placeholder="District Admin Email" value={newDistrict.admin_email} onChange={(e) => setNewDistrict((p) => ({ ...p, admin_email: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <input aria-label="Contracted seats" type="number" min={1} placeholder="Contracted seats" value={newDistrict.seat_quantity} onChange={(e) => setNewDistrict((p) => ({ ...p, seat_quantity: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13 }}>
            <input type="checkbox" checked={newDistrict.is_pilot} onChange={(e) => setNewDistrict((p) => ({ ...p, is_pilot: e.target.checked }))} />
            Pilot offer ($7/student, impl waived)
          </label>
          <select aria-label="Payment schedule" value={newDistrict.billing_interval} onChange={(e) => setNewDistrict((p) => ({ ...p, billing_interval: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
            <option value="annual">Pay in full (annual)</option>
            <option value="monthly">Monthly</option>
            <option value="semester_split">50% at signing + 50% at semester</option>
          </select>
          <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13 }}>
            <input type="checkbox" checked={newDistrict.send_invite} onChange={(e) => setNewDistrict((p) => ({ ...p, send_invite: e.target.checked }))} />
            Send setup-link invite email
          </label>
          <button type="submit" disabled={creatingDistrict} style={{ background: "#3256a2", color: "#fff", border: "none", borderRadius: 6, padding: "8px 12px", cursor: creatingDistrict ? "wait" : "pointer" }}>
            {creatingDistrict ? "Creating…" : "Create District"}
          </button>
        </form>
        {districtResult ? (
          <p style={{ margin: "12px 0 0", fontSize: 13, color: "#6b7280" }}>
            Latest create result (setup link / Resend) is pinned at the top of this page.
          </p>
        ) : null}
      </div>

      {billingDistricts.length > 0 ? (
        <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
          <h2 style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>Districts</h2>
          <div style={{ display: "grid", gap: 8 }}>
            {billingDistricts.map((d) => (
              <div key={d.district_id} style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: 10, display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center" }}>
                <div>
                  <div style={{ fontWeight: 700, color: "#1f2937" }}>{d.name} (ID: {d.district_id})</div>
                  <div style={{ fontSize: 13, color: "#6b7280" }}>
                    {d.billing_status} · seats {d.seat_quantity ?? "—"} · {d.billing_interval || "n/a"}
                    {d.is_pilot ? " · pilot" : ""}
                  </div>
                </div>
                {d.billing_status === "pending_payment" ? (
                  <button
                    type="button"
                    title="Break-glass mark paid"
                    onClick={async () => {
                      try {
                        await forceDistrictBillingStatus(d.district_id, "active", true);
                        setFeedback(`Marked ${d.name} active (break-glass).`);
                        await loadBillingDistricts();
                      } catch (err: any) {
                        setError(err.message || "Force status failed");
                      }
                    }}
                    style={{ background: "#ffa962", color: "#1f2937", border: "none", borderRadius: 6, padding: "6px 10px", cursor: "pointer", fontWeight: 600 }}
                  >
                    Mark paid
                  </button>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>Create School</h2>
        <form onSubmit={handleCreateSchool} style={{ display: "grid", gap: 8 }}>
          <input aria-label="School name" placeholder="School Name" value={newSchool.name} onChange={(e) => setNewSchool((p) => ({ ...p, name: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <input aria-label="School address" placeholder="Address" value={newSchool.address} onChange={(e) => setNewSchool((p) => ({ ...p, address: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <input aria-label="School phone" placeholder="Phone" value={newSchool.phone} onChange={(e) => setNewSchool((p) => ({ ...p, phone: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <select aria-label="School state" value={newSchool.state} onChange={(e) => setNewSchool((p) => ({ ...p, state: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
            <option value="">Select State (for standards scope)</option>
            {US_STATES.map((st) => <option key={st} value={st}>{st}</option>)}
          </select>
          <button type="submit" style={{ background: "#3256a2", color: "#fff", border: "none", borderRadius: 6, padding: "8px 12px", cursor: "pointer" }}>Add School</button>
        </form>
      </div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h3 style={{ margin: "0 0 10px", color: "#3256a2" }}>Schools</h3>
        {loadingSchools ? <div>Loading schools...</div> : (
          <div style={{ display: "grid", gap: 8 }}>
            {schools.map((s) => {
              const isActiveSchool = user?.school_id === s.school_id;
              const hasUsers = (s.user_count || 0) > 0;
              const deleteDisabled = isActiveSchool || hasUsers;
              const deleteReason = isActiveSchool
                ? "Switch to another school before deleting this one"
                : hasUsers
                ? `Cannot delete: ${s.user_count} user(s) still assigned`
                : "Delete school";

              return (
              <div key={s.school_id} style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: 10 }}>
                {editingId === s.school_id ? (
                  <div style={{ display: "grid", gap: 6 }}>
                    <input aria-label="Edit school name" value={editSchool.name} onChange={(e) => setEditSchool((p) => ({ ...p, name: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
                    <input aria-label="Edit school address" value={editSchool.address} onChange={(e) => setEditSchool((p) => ({ ...p, address: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
                    <input aria-label="Edit school phone" value={editSchool.phone} onChange={(e) => setEditSchool((p) => ({ ...p, phone: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
                    <select aria-label="Edit school state" value={editSchool.state} onChange={(e) => setEditSchool((p) => ({ ...p, state: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
                      <option value="">Select State (for standards scope)</option>
                      {US_STATES.map((st) => <option key={st} value={st}>{st}</option>)}
                    </select>
                    <div style={{ display: "flex", gap: 8 }}>
                      <button type="button" onClick={() => saveEdit(s.school_id)} style={{ background: "#3256a2", color: "#fff", border: "none", borderRadius: 6, padding: "6px 10px", cursor: "pointer" }}>Save</button>
                      <button type="button" onClick={() => setEditingId(null)} style={{ background: "#e5e7eb", color: "#111827", border: "none", borderRadius: 6, padding: "6px 10px", cursor: "pointer" }}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center" }}>
                    <div>
                      <div style={{ fontWeight: 700, color: "#1f2937" }}>{s.name} (ID: {s.school_id})</div>
                      <div style={{ fontSize: 13, color: "#6b7280" }}>{s.address || "No address"}</div>
                      <div style={{ fontSize: 13, color: "#6b7280" }}>{s.phone || "No phone"}</div>
                      <div style={{ fontSize: 13, color: "#6b7280" }}>State: {s.state || "Not set"}</div>
                      <div style={{ fontSize: 12, color: hasUsers ? "#b45309" : "#6b7280", marginTop: 2 }}>
                        Users: {s.user_count || 0}
                      </div>
                      {deleteChecks[s.school_id] && !deleteChecks[s.school_id].can_delete && (
                        <div style={{ fontSize: 12, color: "#9f1239", marginTop: 4 }}>
                          Blocked: {deleteChecks[s.school_id].active_school_context ? "active context" : "assigned users"}
                          {deleteChecks[s.school_id].blocking_user_emails?.length > 0 && (
                            <span>
                              {" "}({deleteChecks[s.school_id].blocking_user_emails.slice(0, 3).join(", ")}
                              {deleteChecks[s.school_id].user_count > 3 ? ", ..." : ""})
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      <button type="button" onClick={() => startEdit(s)} style={{ background: "#ffa962", color: "#1f2937", border: "none", borderRadius: 6, padding: "6px 10px", cursor: "pointer", fontWeight: 600 }}>Edit</button>
                      {deleteDisabled && (
                        <button
                          type="button"
                          onClick={() => handleCheckDeleteSchool(s)}
                          style={{
                            background: "#e0e7ff",
                            color: "#3730a3",
                            border: "none",
                            borderRadius: 6,
                            padding: "6px 10px",
                            cursor: "pointer",
                            fontWeight: 600,
                          }}
                        >
                          Why blocked?
                        </button>
                      )}
                      <button
                        type="button"
                        title={deleteReason}
                        disabled={deleteDisabled}
                        onClick={() => handleDeleteSchool(s)}
                        style={{
                          background: deleteDisabled ? "#f3f4f6" : "#dc2626",
                          color: deleteDisabled ? "#9ca3af" : "#fff",
                          border: "none",
                          borderRadius: 6,
                          padding: "6px 10px",
                          cursor: deleteDisabled ? "not-allowed" : "pointer",
                          fontWeight: 600,
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )})}
            {schools.length === 0 && <div>No schools found.</div>}
          </div>
        )}
      </div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>Provision User</h2>
        <form onSubmit={handleProvisionUser} style={{ display: "grid", gap: 8 }}>
          <select aria-label="Provision user school" value={provision.school_id} onChange={(e) => setProvision((p) => ({ ...p, school_id: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
            <option value="">Select School</option>
            {schools.map((s) => <option key={s.school_id} value={s.school_id}>{s.name} (ID: {s.school_id})</option>)}
          </select>
          <select aria-label="Provision user role" value={provision.role} onChange={(e) => setProvision((p) => ({ ...p, role: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
            <option value="admin">Admin</option>
            <option value="teacher">Teacher</option>
            <option value="student">Student</option>
            <option value="parent">Family</option>
          </select>
          <input aria-label="Provision first name" placeholder="First Name" value={provision.first_name} onChange={(e) => setProvision((p) => ({ ...p, first_name: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <input aria-label="Provision last name" placeholder="Last Name" value={provision.last_name} onChange={(e) => setProvision((p) => ({ ...p, last_name: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <input aria-label="Provision email" type="email" placeholder="Email" value={provision.email} onChange={(e) => setProvision((p) => ({ ...p, email: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <input aria-label="Temporary password" type={showProvisionPassword ? "text" : "password"} placeholder="Temporary Password" value={provision.password} onChange={(e) => setProvision((p) => ({ ...p, password: e.target.value }))} required style={{ flex: 1, padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
            <button type="button" onClick={() => setShowProvisionPassword((visible) => !visible)} aria-label={showProvisionPassword ? "Hide temporary password" : "Show temporary password"} style={{ background: "#e5e7eb", color: "#1f2937", border: "none", borderRadius: 6, padding: "8px 10px", cursor: "pointer", fontWeight: 600 }}>
              {showProvisionPassword ? "Hide" : "Show"}
            </button>
          </div>
          <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, color: "#374151" }}>
            <input type="checkbox" checked={provision.send_invite} onChange={(e) => setProvision((p) => ({ ...p, send_invite: e.target.checked }))} />
            Email login credentials to this user (requires SES to be configured)
          </label>
          <button type="submit" style={{ background: "#3256a2", color: "#fff", border: "none", borderRadius: 6, padding: "8px 12px", cursor: "pointer" }}>Create User</button>
        </form>
      </div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 style={{ margin: "0 0 6px", color: "#3256a2", fontSize: 18 }}>Demo Users</h2>
        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 10 }}>
          Each demo user gets an isolated demo school. Explicit logout and Reset Demo Activity remove activity created there without touching real schools or users.
          {" "}Parent demos include a linked sample child; student demos include a Grade 3 profile. These starter profiles are restored after reset or logout.
          {" "}Teacher demos are read-only, with Home and Student Profiles only; new/reset accounts include one sample student with Mathematics progress.
        </div>
        <form onSubmit={handleCreateDemoUser} style={{ display: "grid", gap: 8, marginBottom: 14 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            <input aria-label="Demo first name" placeholder="First Name" value={demoProvision.first_name} onChange={(e) => setDemoProvision((p) => ({ ...p, first_name: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
            <input aria-label="Demo last name" placeholder="Last Name" value={demoProvision.last_name} onChange={(e) => setDemoProvision((p) => ({ ...p, last_name: e.target.value }))} required style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          </div>
          <select aria-label="Demo account role" value={demoProvision.role} onChange={(e) => setDemoProvision((p) => ({ ...p, role: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
            <option value="school_admin">School Admin</option>
            <option value="district_admin">District Admin</option>
            <option value="teacher">Teacher</option>
            <option value="parent">Parent (Family)</option>
            <option value="student">Student</option>
          </select>
          <input aria-label="Demo login email" type="email" placeholder="Login email (optional; auto-generated if blank)" value={demoProvision.email} onChange={(e) => setDemoProvision((p) => ({ ...p, email: e.target.value }))} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <input aria-label="Demo password" type={showDemoProvisionPassword ? "text" : "password"} placeholder="Password (optional; temporary password generated if blank)" value={demoProvision.password} onChange={(e) => setDemoProvision((p) => ({ ...p, password: e.target.value }))} style={{ flex: 1, padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }} />
            <button type="button" onClick={() => setShowDemoProvisionPassword((visible) => !visible)} aria-label={showDemoProvisionPassword ? "Hide demo password" : "Show demo password"} style={{ background: "#e5e7eb", color: "#1f2937", border: "none", borderRadius: 6, padding: "8px 10px", cursor: "pointer", fontWeight: 600 }}>
              {showDemoProvisionPassword ? "Hide" : "Show"}
            </button>
          </div>
          <button type="submit" style={{ background: "#0f766e", color: "#fff", border: "none", borderRadius: 6, padding: "8px 12px", cursor: "pointer" }}>Create Demo User</button>
        </form>
        {loadingDemoUsers ? (
          <div style={{ fontSize: 13, color: "#6b7280" }}>Loading demo users...</div>
        ) : demoUsers.length === 0 ? (
          <div style={{ fontSize: 13, color: "#6b7280" }}>No demo users created.</div>
        ) : (
          <div style={{ display: "grid", gap: 8 }}>
            {demoUsers.map((demoUser) => (
              <div key={demoUser.user_id} style={{ border: "1px solid #d1fae5", background: "#f0fdf4", borderRadius: 8, padding: 10, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <div>
                  <div style={{ fontWeight: 700, color: "#1f2937" }}>{demoUser.first_name} {demoUser.last_name} <span style={{ fontSize: 11, color: "#047857" }}>DEMO</span></div>
                  <div style={{ fontSize: 13, color: "#4b5563" }}>{demoUser.email} · {demoUser.role}</div>
                  <div style={{ fontSize: 12, color: "#6b7280" }}>{demoUser.school_name}</div>
                </div>
                <button type="button" disabled={resettingDemoUserId === demoUser.user_id} onClick={() => handleResetDemoUser(demoUser)} style={{ background: resettingDemoUserId === demoUser.user_id ? "#f3f4f6" : "#fef3c7", color: resettingDemoUserId === demoUser.user_id ? "#9ca3af" : "#92400e", border: "none", borderRadius: 6, padding: "6px 10px", cursor: resettingDemoUserId === demoUser.user_id ? "not-allowed" : "pointer", fontWeight: 600 }}>{resettingDemoUserId === demoUser.user_id ? "Resetting..." : "Reset Demo Activity"}</button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>Grant Existing Admin Access</h2>
        <form onSubmit={handleGrantAdminAccess} style={{ display: "grid", gap: 8 }}>
          <select
            aria-label="Grant admin access school"
            value={grantAdmin.school_id}
            onChange={(e) => setGrantAdmin((p) => ({ ...p, school_id: e.target.value }))}
            required
            style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
          >
            <option value="">Select School</option>
            {schools.map((s) => (
              <option key={s.school_id} value={s.school_id}>
                {s.name} (ID: {s.school_id})
              </option>
            ))}
          </select>
          <input
            type="email"
            aria-label="Existing admin email"
            placeholder="Existing Admin Email"
            value={grantAdmin.email}
            onChange={(e) => setGrantAdmin((p) => ({ ...p, email: e.target.value }))}
            required
            style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
          />
          <select
            aria-label="Admin access level"
            value={grantAdmin.access_level}
            onChange={(e) => setGrantAdmin((p) => ({ ...p, access_level: e.target.value }))}
            style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
          >
            <option value="school_admin">school_admin</option>
            <option value="district_admin">district_admin</option>
            <option value="read_only">read_only</option>
          </select>
          <button
            type="submit"
            style={{ background: "#3256a2", color: "#fff", border: "none", borderRadius: 6, padding: "8px 12px", cursor: "pointer" }}
          >
            Grant Access
          </button>
        </form>
      </div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>Current Admin Access by School</h2>
        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 10 }}>
          "Revoke" removes this school's access mapping only. "Reset &amp; View Password" issues a new
          temporary password (shown once) that the admin must change on next login. "Delete Account"
          fully deletes the admin's account and removes their access to ALL schools.
        </div>
        <div style={{ display: "grid", gap: 8 }}>
          <select
            aria-label="Admin access school filter"
            value={adminAccessSchoolId}
            onChange={async (e) => {
              const nextId = e.target.value;
              setAdminAccessSchoolId(nextId);
              setAdminAuditPage(1);
              setAdminRevealedPasswords({});
              await loadSchoolAdmins(nextId);
              await loadSchoolAdminAudit(nextId, {
                page: 1,
                limit: adminAuditLimit,
                actionPrefix: adminAuditActionPrefix,
                startDate: adminAuditStartDate,
                endDate: adminAuditEndDate,
              });
            }}
            style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
          >
            <option value="">Select School</option>
            {schools.map((s) => (
              <option key={s.school_id} value={s.school_id}>
                {s.name} (ID: {s.school_id})
              </option>
            ))}
          </select>

          {!adminAccessSchoolId ? (
            <div style={{ fontSize: 13, color: "#6b7280" }}>Select a school to view admin access mappings.</div>
          ) : loadingSchoolAdmins ? (
            <div style={{ fontSize: 13, color: "#6b7280" }}>Loading admin access...</div>
          ) : schoolAdmins.length === 0 ? (
            <div style={{ fontSize: 13, color: "#6b7280" }}>No admin mappings found for this school.</div>
          ) : (
            <div style={{ display: "grid", gap: 8 }}>
              {schoolAdmins.map((adm) => (
                <div key={`${adm.user_id}-${adm.admin_school_id}`} style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: 10, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
                  <div>
                    <div style={{ fontWeight: 700, color: "#1f2937" }}>
                      {adm.first_name || ""} {adm.last_name || ""}
                    </div>
                    <div style={{ fontSize: 13, color: "#6b7280" }}>{adm.email}</div>
                    <div style={{ fontSize: 12, color: "#4b5563" }}>Access: {adm.access_level}</div>
                    {adminRevealedPasswords[adm.user_id] && (
                      <div style={{ fontSize: 12, color: "#065f46", marginTop: 4, fontFamily: "monospace" }}>
                        Temp password: {adminRevealedPasswords[adm.user_id]} (shown once — share securely)
                      </div>
                    )}
                  </div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                    <select
                      aria-label={`Access level for ${adm.email || adm.user_id}`}
                      value={adminAccessEdits[adm.user_id] || adm.access_level}
                      onChange={(e) => setAdminAccessEdits((prev) => ({ ...prev, [adm.user_id]: e.target.value }))}
                      style={{ padding: 6, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12 }}
                    >
                      <option value="school_admin">school_admin</option>
                      <option value="district_admin">district_admin</option>
                      <option value="read_only">read_only</option>
                    </select>
                    <button
                      type="button"
                      onClick={() => handleUpdateAdminAccessLevel(adm)}
                      style={{ background: "#2563eb", color: "#fff", border: "none", borderRadius: 6, padding: "6px 10px", cursor: "pointer", fontWeight: 600 }}
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      disabled={resettingAdminId === adm.user_id}
                      onClick={() => handleResetAdminPassword(adm)}
                      style={{
                        background: resettingAdminId === adm.user_id ? "#f3f4f6" : "#0f766e",
                        color: resettingAdminId === adm.user_id ? "#9ca3af" : "#fff",
                        border: "none",
                        borderRadius: 6,
                        padding: "6px 10px",
                        cursor: resettingAdminId === adm.user_id ? "not-allowed" : "pointer",
                        fontWeight: 600,
                        fontSize: 13,
                      }}
                    >
                      {resettingAdminId === adm.user_id ? "Resetting..." : "Reset & View Password"}
                    </button>
                    <button
                      type="button"
                      onClick={() => handleRevokeAdminAccess(adm)}
                      style={{ background: "#dc2626", color: "#fff", border: "none", borderRadius: 6, padding: "6px 10px", cursor: "pointer", fontWeight: 600 }}
                    >
                      Revoke
                    </button>
                    <button
                      type="button"
                      disabled={deletingAdminId === adm.user_id}
                      onClick={() => handleDeleteAdminAccount(adm)}
                      style={{
                        background: deletingAdminId === adm.user_id ? "#f3f4f6" : "#fee2e2",
                        color: deletingAdminId === adm.user_id ? "#9ca3af" : "#991b1b",
                        border: "none",
                        borderRadius: 6,
                        padding: "6px 10px",
                        cursor: deletingAdminId === adm.user_id ? "not-allowed" : "pointer",
                        fontWeight: 600,
                        fontSize: 13,
                      }}
                    >
                      {deletingAdminId === adm.user_id ? "Deleting..." : "Delete Account"}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>Teachers by School</h2>
        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 10 }}>
          Existing passwords are stored as one-way hashes and can never be viewed. Use "Reset &amp; View Password"
          to issue a new temporary password, shown once, that the teacher must change on next login.
        </div>
        <div style={{ display: "grid", gap: 8 }}>
          <select
            aria-label="Teachers school filter"
            value={teacherSchoolId}
            onChange={async (e) => {
              const nextId = e.target.value;
              setTeacherSchoolId(nextId);
              setRevealedPasswords({});
              await loadSchoolTeachers(nextId);
            }}
            style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
          >
            <option value="">Select School</option>
            {schools.map((s) => (
              <option key={s.school_id} value={s.school_id}>
                {s.name} (ID: {s.school_id})
              </option>
            ))}
          </select>

          {!teacherSchoolId ? (
            <div style={{ fontSize: 13, color: "#6b7280" }}>Select a school/building to view its teachers.</div>
          ) : loadingTeachers ? (
            <div style={{ fontSize: 13, color: "#6b7280" }}>Loading teachers...</div>
          ) : teachers.length === 0 ? (
            <div style={{ fontSize: 13, color: "#6b7280" }}>No teachers found for this school.</div>
          ) : (
            <div style={{ display: "grid", gap: 8 }}>
              {teachers.map((t) => (
                <div key={t.user_id} style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: 10 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                    <div>
                      <div style={{ fontWeight: 700, color: "#1f2937" }}>
                        {t.first_name || ""} {t.last_name || ""}
                      </div>
                      <div style={{ fontSize: 13, color: "#6b7280" }}>{t.email}</div>
                      {t.must_change_password && (
                        <div style={{ fontSize: 12, color: "#b45309" }}>Must change password on next login</div>
                      )}
                    </div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      <button
                        type="button"
                        disabled={resettingTeacherId === t.user_id}
                        onClick={() => handleResetTeacherPassword(t)}
                        style={{
                          background: resettingTeacherId === t.user_id ? "#f3f4f6" : "#2563eb",
                          color: resettingTeacherId === t.user_id ? "#9ca3af" : "#fff",
                          border: "none",
                          borderRadius: 6,
                          padding: "6px 10px",
                          cursor: resettingTeacherId === t.user_id ? "not-allowed" : "pointer",
                          fontWeight: 600,
                          fontSize: 13,
                        }}
                      >
                        {resettingTeacherId === t.user_id ? "Resetting..." : "Reset & View Password"}
                      </button>
                      <button
                        type="button"
                        disabled={deletingTeacherId === t.user_id}
                        onClick={() => handleDeleteTeacher(t)}
                        style={{
                          background: deletingTeacherId === t.user_id ? "#f3f4f6" : "#fee2e2",
                          color: deletingTeacherId === t.user_id ? "#9ca3af" : "#991b1b",
                          border: "none",
                          borderRadius: 6,
                          padding: "6px 10px",
                          cursor: deletingTeacherId === t.user_id ? "not-allowed" : "pointer",
                          fontWeight: 600,
                          fontSize: 13,
                        }}
                      >
                        {deletingTeacherId === t.user_id ? "Deleting..." : "Delete"}
                      </button>
                    </div>
                  </div>
                  {revealedPasswords[t.user_id] && (
                    <div
                      style={{
                        marginTop: 8,
                        padding: 8,
                        background: "#eff6ff",
                        border: "1px solid #bfdbfe",
                        borderRadius: 6,
                        fontSize: 13,
                        color: "#1e3a8a",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <span>
                        Temporary password: <code style={{ fontWeight: 700 }}>{revealedPasswords[t.user_id]}</code>
                      </span>
                      <button
                        type="button"
                        onClick={() => navigator.clipboard?.writeText(revealedPasswords[t.user_id])}
                        style={{ background: "#1d4ed8", color: "#fff", border: "none", borderRadius: 6, padding: "4px 8px", cursor: "pointer", fontSize: 12, fontWeight: 600 }}
                      >
                        Copy
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>Standards Visibility by State</h2>
        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 10 }}>
          Choose which standards Admins and Teachers see when they switch to the "Standard Set" view for a
          quarter, trimester, unit, or semester. Scoped per state, subject, and grade band. Admins/Teachers
          can still switch back to "Standard (All)" view at any time from their own preferences.
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 8, marginBottom: 10 }}>
          <select
            aria-label="Standards visibility state"
            value={scopeState}
            onChange={async (e) => {
              const nextState = e.target.value;
              setScopeState(nextState);
              setScopeSelectedCodes(new Set());
              setScopeMessage("");
              await loadScopeSummary(nextState);
            }}
            style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
          >
            <option value="">Select State</option>
            {US_STATES.map((st) => <option key={st} value={st}>{st}</option>)}
          </select>
          <select aria-label="Scope subject" value={scopeSubject} onChange={(e) => setScopeSubject(e.target.value)} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
            {SCOPE_SUBJECTS.map((subj) => <option key={subj} value={subj}>{subj}</option>)}
          </select>
          <select aria-label="Scope grade band" value={scopeGradeBand} onChange={(e) => setScopeGradeBand(e.target.value)} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
            {SCOPE_GRADE_BANDS.map((band) => <option key={band} value={band}>{band}</option>)}
          </select>
          <select aria-label="Scope time frame type" value={scopeTimeFrameType} onChange={(e) => setScopeTimeFrameType(e.target.value)} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
            {SCOPE_TIME_FRAME_TYPES.map((type) => <option key={type} value={type}>{type}</option>)}
          </select>
          <input
            aria-label="Scope time frame label"
            placeholder={scopeTimeFrameType === "year" ? "Time frame label (e.g. Full Year)" : "Time frame label (e.g. Quarter 1)"}
            value={scopeTimeFrameLabel}
            onChange={(e) => setScopeTimeFrameLabel(e.target.value)}
            style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
          />
          <button
            type="button"
            onClick={loadScopeRules}
            disabled={loadingScopeRules}
            style={{ background: loadingScopeRules ? "#f3f4f6" : "#e5e7eb", color: "#111827", border: "none", borderRadius: 6, padding: "8px 12px", cursor: loadingScopeRules ? "not-allowed" : "pointer", fontWeight: 600 }}
          >
            {loadingScopeRules ? "Loading..." : "Load Standards"}
          </button>
        </div>

        {scopeMessage && <div style={{ color: "#065f46", background: "#ecfdf5", border: "1px solid #a7f3d0", padding: 8, borderRadius: 6, fontSize: 13, marginBottom: 8 }}>{scopeMessage}</div>}
        {scopeError && <div style={{ color: "#991b1b", background: "#fef2f2", border: "1px solid #fecaca", padding: 8, borderRadius: 6, fontSize: 13, marginBottom: 8 }}>{scopeError}</div>}

        {loadingAllStandards ? (
          <div style={{ fontSize: 13, color: "#6b7280" }}>Loading standards catalog...</div>
        ) : scopeCandidateStandards.length === 0 ? (
          <div style={{ fontSize: 13, color: "#6b7280" }}>No standards found for {scopeSubject} · {scopeGradeBand}.</div>
        ) : (
          <>
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>
              {scopeSelectedCodes.size} of {scopeCandidateStandards.length} standards marked visible for this scope.
            </div>
            <div style={{ maxHeight: 320, overflowY: "auto", display: "grid", gap: 4, border: "1px solid #f0f0f0", borderRadius: 8, padding: 8 }}>
              {scopeCandidateStandards.map((row) => (
                <label key={row.mls_code} style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 12, padding: "4px 6px", borderRadius: 4, cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={scopeSelectedCodes.has(row.mls_code)}
                    onChange={() => toggleScopeCode(row.mls_code)}
                    style={{ marginTop: 2 }}
                  />
                  <span>
                    <strong>{row.mls_code}</strong>{" "}
                    <span style={{ color: "#6b7280" }}>
                      {row.standard_description || row.cluster_expectation_description || ""}
                    </span>
                  </span>
                </label>
              ))}
            </div>
            <button
              type="button"
              onClick={handleSaveScopeRules}
              disabled={savingScopeRules}
              style={{
                marginTop: 10,
                background: savingScopeRules ? "#9ca3af" : "#3256a2",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                padding: "8px 14px",
                cursor: savingScopeRules ? "not-allowed" : "pointer",
                fontWeight: 600,
              }}
            >
              {savingScopeRules ? "Saving..." : "Save Visible Standards"}
            </button>
          </>
        )}

        {scopeState && (
          <div style={{ marginTop: 16 }}>
            <div style={{ fontWeight: 700, color: "#1f2937", fontSize: 13, marginBottom: 6 }}>
              Configured scopes for {scopeState}
            </div>
            {loadingScopeSummary ? (
              <div style={{ fontSize: 13, color: "#6b7280" }}>Loading...</div>
            ) : scopeSummary.length === 0 ? (
              <div style={{ fontSize: 13, color: "#6b7280" }}>No scopes configured yet for this state.</div>
            ) : (
              <div style={{ display: "grid", gap: 6 }}>
                {scopeSummary.map((sc, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 10,
                      fontSize: 12,
                      color: "#374151",
                      border: "1px solid #f0f0f0",
                      borderRadius: 6,
                      padding: "6px 10px",
                    }}
                  >
                    <span>
                      {sc.subject} · {sc.grade_band} · {sc.time_frame_type} "{sc.time_frame_label}" — {sc.standard_count} standard{sc.standard_count === 1 ? "" : "s"}
                    </span>
                    <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                      <button
                        type="button"
                        onClick={() => handleEditScope(sc)}
                        style={{ background: "#e5e7eb", color: "#111827", border: "none", borderRadius: 6, padding: "4px 10px", cursor: "pointer", fontSize: 11, fontWeight: 600 }}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDeleteScope(sc)}
                        style={{ background: "#fee2e2", color: "#991b1b", border: "none", borderRadius: 6, padding: "4px 10px", cursor: "pointer", fontSize: 11, fontWeight: 600 }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>Science Standards Preference by School</h2>
        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 10 }}>
          Choose Missouri or NGSS Science standards for all grades at a school. All other subjects continue using Missouri standards.
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 8, marginBottom: 10 }}>
          <select
            aria-label="Science standards school"
            value={schoolScopeId}
            onChange={async (e) => {
              const nextSchoolId = e.target.value;
              setSchoolScopeId(nextSchoolId);
              setScopeSelectedCodes(new Set());
              await loadSchoolScopeRules({ schoolId: nextSchoolId });
            }}
            style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
          >
            <option value="">Select School</option>
            {schools.map((school) => <option key={school.school_id} value={school.school_id}>{school.name}</option>)}
          </select>
          <select aria-label="Science standards source" value={districtScopeSource} onChange={(e) => setDistrictScopeSource(e.target.value)} style={{ padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}>
            <option value="missouri">Missouri Science</option>
            <option value="ngss">NGSS Science</option>
          </select>
          <button
            type="button"
            onClick={handleSaveSchoolScienceSource}
            disabled={!schoolScopeId || savingScopeRules}
            style={{ background: !schoolScopeId || savingScopeRules ? "#f3f4f6" : "#3256a2", color: !schoolScopeId || savingScopeRules ? "#6b7280" : "#fff", border: "none", borderRadius: 6, padding: "8px 12px", cursor: !schoolScopeId || savingScopeRules ? "not-allowed" : "pointer", fontWeight: 600 }}
          >
            {savingScopeRules ? "Saving..." : "Save Science Preference"}
          </button>
        </div>
        {scopeMessage && <div style={{ color: "#065f46", background: "#ecfdf5", border: "1px solid #a7f3d0", padding: 8, borderRadius: 6, fontSize: 13 }}>{scopeMessage}</div>}
        {scopeError && <div style={{ color: "#991b1b", background: "#fef2f2", border: "1px solid #fecaca", padding: 8, borderRadius: 6, fontSize: 13 }}>{scopeError}</div>}
      </div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, background: "#fff" }}>
        <h2 style={{ margin: "0 0 10px", color: "#3256a2", fontSize: 18 }}>Admin Access Audit</h2>
        <div style={{ display: "flex", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
          <select
            aria-label="Audit action filter"
            value={adminAuditActionPrefix}
            onChange={async (e) => {
              const next = e.target.value;
              setAdminAuditActionPrefix(next);
              setAdminAuditPage(1);
              if (adminAccessSchoolId) {
                await loadSchoolAdminAudit(adminAccessSchoolId, {
                  page: 1,
                  limit: adminAuditLimit,
                  actionPrefix: next,
                  startDate: adminAuditStartDate,
                  endDate: adminAuditEndDate,
                });
              }
            }}
            style={{ padding: 6, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12 }}
          >
            <option value="">All actions</option>
            <option value="admin_access_granted">Granted</option>
            <option value="admin_access_revoked">Revoked</option>
            <option value="admin_access_level_updated">Level updated</option>
          </select>
          <select
            aria-label="Audit page size"
            value={adminAuditLimit}
            onChange={async (e) => {
              const next = Number(e.target.value);
              setAdminAuditLimit(next);
              setAdminAuditPage(1);
              if (adminAccessSchoolId) {
                await loadSchoolAdminAudit(adminAccessSchoolId, {
                  page: 1,
                  limit: next,
                  actionPrefix: adminAuditActionPrefix,
                  startDate: adminAuditStartDate,
                  endDate: adminAuditEndDate,
                });
              }
            }}
            style={{ padding: 6, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12 }}
          >
            <option value={10}>10 / page</option>
            <option value={25}>25 / page</option>
            <option value={50}>50 / page</option>
          </select>
          <input
            type="text"
            aria-label="Search audit log"
            value={adminAuditSearchTerm}
            onChange={(e) => setAdminAuditSearchTerm(e.target.value)}
            placeholder="Search actor, target, action, or access"
            style={{ padding: 6, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12, minWidth: 230 }}
          />
          <input
            type="date"
            aria-label="Audit start date"
            value={adminAuditStartDate}
            onChange={async (e) => {
              const next = e.target.value;
              setAdminAuditStartDate(next);
              setAdminAuditPreset("");
              setAdminAuditPage(1);
              if (adminAccessSchoolId) {
                await loadSchoolAdminAudit(adminAccessSchoolId, {
                  page: 1,
                  limit: adminAuditLimit,
                  actionPrefix: adminAuditActionPrefix,
                  startDate: next,
                  endDate: adminAuditEndDate,
                });
              }
            }}
            style={{ padding: 6, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12 }}
          />
          <input
            type="date"
            aria-label="Audit end date"
            value={adminAuditEndDate}
            onChange={async (e) => {
              const next = e.target.value;
              setAdminAuditEndDate(next);
              setAdminAuditPreset("");
              setAdminAuditPage(1);
              if (adminAccessSchoolId) {
                await loadSchoolAdminAudit(adminAccessSchoolId, {
                  page: 1,
                  limit: adminAuditLimit,
                  actionPrefix: adminAuditActionPrefix,
                  startDate: adminAuditStartDate,
                  endDate: next,
                });
              }
            }}
            style={{ padding: 6, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12 }}
          />
          <button
            type="button"
            onClick={async () => {
              await applyAuditDatePreset(0, "today");
            }}
            style={{
              background: adminAuditPreset === "today" ? "#1d4ed8" : "#dbeafe",
              color: adminAuditPreset === "today" ? "#ffffff" : "#1d4ed8",
              border: "none",
              borderRadius: 6,
              padding: "6px 10px",
              cursor: "pointer",
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Today
          </button>
          <button
            type="button"
            onClick={async () => {
              await applyAuditDatePreset(6, "last7");
            }}
            style={{
              background: adminAuditPreset === "last7" ? "#1d4ed8" : "#dbeafe",
              color: adminAuditPreset === "last7" ? "#ffffff" : "#1d4ed8",
              border: "none",
              borderRadius: 6,
              padding: "6px 10px",
              cursor: "pointer",
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Last 7 days
          </button>
          <button
            type="button"
            onClick={async () => {
              await applyAuditDatePreset(29, "last30");
            }}
            style={{
              background: adminAuditPreset === "last30" ? "#1d4ed8" : "#dbeafe",
              color: adminAuditPreset === "last30" ? "#ffffff" : "#1d4ed8",
              border: "none",
              borderRadius: 6,
              padding: "6px 10px",
              cursor: "pointer",
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Last 30 days
          </button>
          <button
            type="button"
            onClick={async () => {
              setAdminAuditStartDate("");
              setAdminAuditEndDate("");
              setAdminAuditPreset("");
              setAdminAuditPage(1);
              if (adminAccessSchoolId) {
                await loadSchoolAdminAudit(adminAccessSchoolId, {
                  page: 1,
                  limit: adminAuditLimit,
                  actionPrefix: adminAuditActionPrefix,
                  startDate: "",
                  endDate: "",
                });
              }
            }}
            style={{
              background: "#e5e7eb",
              color: "#111827",
              border: "none",
              borderRadius: 6,
              padding: "6px 10px",
              cursor: "pointer",
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Clear dates
          </button>
        </div>
        {!adminAccessSchoolId ? (
          <div style={{ fontSize: 13, color: "#6b7280" }}>Select a school to view recent admin access changes.</div>
        ) : loadingAdminAudit ? (
          <div style={{ fontSize: 13, color: "#6b7280" }}>Loading audit events...</div>
        ) : filteredAdminAuditEvents.length === 0 ? (
          <div style={{ fontSize: 13, color: "#6b7280" }}>
            {adminAuditEvents.length === 0
              ? "No audit events found for this school."
              : "No matching audit events on this page for the current search."}
          </div>
        ) : (
          <div style={{ display: "grid", gap: 8 }}>
            {filteredAdminAuditEvents.map((evt) => (
              <div key={evt.log_id} style={{ border: "1px solid #f0f0f0", borderRadius: 8, padding: 10 }}>
                {(() => {
                  const parsed = parseAuditAction(evt.action);
                  return (
                    <>
                      <div style={{ fontWeight: 700, color: "#1f2937", fontSize: 13 }}>{parsed.actionLabel}</div>
                      <div style={{ fontSize: 12, color: "#4b5563", marginTop: 2 }}>
                        Target User: {parsed.details.target_user_id || "unknown"}
                        {parsed.details.access_level ? ` • Access: ${parsed.details.access_level}` : ""}
                      </div>
                    </>
                  );
                })()}
                <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
                  {evt.actor_email || `user_id=${evt.actor_user_id || "unknown"}`} · {formatAuditTimestamp(evt.created_at)}
                </div>
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 4 }}>
              <div style={{ fontSize: 12, color: "#6b7280" }}>
                Page {adminAuditPage} of {adminAuditTotalPages} · {adminAuditTotal} total
                {normalizedAuditSearch ? ` · ${filteredAdminAuditEvents.length} shown` : ""}
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button
                  type="button"
                  disabled={adminAuditPage <= 1}
                  onClick={async () => {
                    const nextPage = adminAuditPage - 1;
                    setAdminAuditPage(nextPage);
                    await loadSchoolAdminAudit(adminAccessSchoolId, {
                      page: nextPage,
                      limit: adminAuditLimit,
                      actionPrefix: adminAuditActionPrefix,
                      startDate: adminAuditStartDate,
                      endDate: adminAuditEndDate,
                    });
                  }}
                  style={{
                    background: adminAuditPage <= 1 ? "#f3f4f6" : "#e5e7eb",
                    color: "#111827",
                    border: "none",
                    borderRadius: 6,
                    padding: "6px 10px",
                    cursor: adminAuditPage <= 1 ? "not-allowed" : "pointer",
                    fontSize: 12,
                    fontWeight: 600,
                  }}
                >
                  Previous
                </button>
                <button
                  type="button"
                  disabled={adminAuditPage >= adminAuditTotalPages}
                  onClick={async () => {
                    const nextPage = adminAuditPage + 1;
                    setAdminAuditPage(nextPage);
                    await loadSchoolAdminAudit(adminAccessSchoolId, {
                      page: nextPage,
                      limit: adminAuditLimit,
                      actionPrefix: adminAuditActionPrefix,
                      startDate: adminAuditStartDate,
                      endDate: adminAuditEndDate,
                    });
                  }}
                  style={{
                    background: adminAuditPage >= adminAuditTotalPages ? "#f3f4f6" : "#e5e7eb",
                    color: "#111827",
                    border: "none",
                    borderRadius: 6,
                    padding: "6px 10px",
                    cursor: adminAuditPage >= adminAuditTotalPages ? "not-allowed" : "pointer",
                    fontSize: 12,
                    fontWeight: 600,
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {blockerModal.open && blockerModal.data && (
        <ModalPortal>
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: 16,
          }}
          onClick={() => setBlockerModal({ open: false, data: null })}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 520,
              maxHeight: "80vh",
              overflowY: "auto",
              background: "#fff",
              borderRadius: 10,
              border: "1px solid #e5e7eb",
              padding: 16,
              boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ marginTop: 0, marginBottom: 10, color: "#7f1d1d" }}>Delete Blocked</h3>
            <div style={{ fontSize: 14, color: "#374151", marginBottom: 10 }}>
              <strong>{blockerModal.data.school_name}</strong> (ID: {blockerModal.data.school_id}) cannot be deleted right now.
            </div>

            <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 8 }}>
              Reasons: {blockerModal.data.reasons?.join(", ") || "unknown"}
            </div>
            <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 8 }}>
              Users assigned: {blockerModal.data.user_count || 0}
            </div>

            {blockerModal.data.blocking_user_emails?.length > 0 && (
              <div style={{ marginTop: 12 }}>
                <div style={{ fontWeight: 600, color: "#1f2937", marginBottom: 6, fontSize: 13 }}>
                  Blocking user emails (first {blockerModal.data.blocking_user_emails.length})
                </div>
                <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13, color: "#374151" }}>
                  {blockerModal.data.blocking_user_emails.map((email) => (
                    <li key={email}>{email}</li>
                  ))}
                </ul>
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button
                type="button"
                onClick={() => setBlockerModal({ open: false, data: null })}
                style={{
                  background: "#e5e7eb",
                  color: "#111827",
                  border: "none",
                  borderRadius: 6,
                  padding: "8px 12px",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
        </ModalPortal>
      )}
      <BackToTop />
    </div>
  );
}
